import { ref } from 'vue';
import { CookieOption } from '@jaaluu/interfaces/CookieOption';
import { t } from '@shared/i18n';

const COOKIE_CONSENT_KEY = 'cookieConsents';

const TOOLTIPS = {
  [CookieOption.NECESSARY]: t('cookies.tooltip_necessary'),
  [CookieOption.PREFERENCES]: t('cookies.tooltip_preferences'),
  [CookieOption.STATISTICS]: t('cookies.tooltip_statistics'),
  [CookieOption.MARKETING]: t('cookies.tooltip_marketing')
};

export default () => {
  const cookieDialogIsOpen = ref(false);
  const cookieDialogFromSettings = ref(false);
  const userConsent = ref({
    [CookieOption.NECESSARY]: true,
    [CookieOption.PREFERENCES]: true,
    [CookieOption.STATISTICS]: true,
    [CookieOption.MARKETING]: true
  });

  const setCookieConsentInLs = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(userConsent.value));
    updateGTagConsent();
  };

  const getCookieConsentFromLs = () => {
    const userConsentLs = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (userConsentLs) {
      userConsent.value = JSON.parse(userConsentLs);
      updateGTagConsent();
    } else {
      cookieDialogIsOpen.value = true;
    }
  };

  const updateGTagConsent = () => {
    const { preferences, statistics, marketing } = userConsent.value;
    if ((window as any).gtag) {
      console.log('Updating gtag consent ', { preferences, statistics, marketing });
      (window as any).gtag('consent', 'update', {
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: preferences ? 'granted' : 'denied',
        analytics_storage: statistics ? 'granted' : 'denied',
        ad_personalization: preferences ? 'granted' : 'denied',
        wait_for_update: 500
      });
    }
  }

  return {
    state: { userConsent, cookieDialogIsOpen, cookieDialogFromSettings },
    funcs: { setCookieConsentInLs, getCookieConsentFromLs, updateGTagConsent },
    consts: { TOOLTIPS }
  };
};
